import React from "react";
import { Center, Loader, Paper, Stack, Text } from "@mantine/core";
import { DeckBimViewer } from "@multiconsult-group/multiplacer-ui";
import { useAppSelector } from "../app/hooks";
import { selectDrofusOccurrenceRoomViewerCanvasModel } from "./drofusOccurrenceRoomViewerSelectors";

export const DrofusOccurrenceRoomViewerCanvas: React.FC = () => {
  const { ceilingGridPaths, polygons, rotation, isFetchingItems, zoomExtentKey } = useAppSelector(
    selectDrofusOccurrenceRoomViewerCanvasModel
  );

  return (
    <Paper
      bg="gray.0"
      radius="sm"
      p="xs"
      h="100%"
      withBorder
      style={{ minHeight: 0, position: "relative" }}
    >
      {polygons.length > 0 ? (
        <DeckBimViewer
          flip2dCoordinate={true}
          angle={rotation}
          paths={ceilingGridPaths}
          polygons={polygons}
          zoomExtentKey={zoomExtentKey}
        />
      ) : (
        <Center h="100%">
          <Text size="sm" c="dimmed">
            Ingen IFC-geometri funnet for rommet.
          </Text>
        </Center>
      )}
      {isFetchingItems && (
        <Center
          h="100%"
          w="100%"
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255, 255, 255, 0.68)",
            zIndex: 2,
          }}
        >
          <Stack gap="xs" align="center">
            <Loader size="sm" />
            <Text size="xs" c="dimmed">
              Laster komponenter
            </Text>
          </Stack>
        </Center>
      )}
    </Paper>
  );
};
